import React from 'react';
import {UsePermissions} from "../../hooks/usePermissions";
import AjusteFondoTable from "./components/AjusteFondoTable";
import {Navigate} from "react-router";

const AjusteFondoPage = () => {
    const [permisos] = UsePermissions();
    return (
        <div className="container-relative">
            {permisos.consultar ? <AjusteFondoTable />: <Navigate to="/home"/> }
        </div>
    );
};

export default AjusteFondoPage;
